module.exports = __webpack_public_path__ + "img/SearchOnlineCarsLogoColor.a6965830.png";